import { makeStyles } from '@material-ui/core';

export default makeStyles(
  (theme) => ({
    popper: {
      zIndex: theme.zIndex.tooltip,
    },
    root: {
      position: 'relative',

      padding: '15px',

      maxWidth: '315px',
      backgroundColor: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightRegular,
      color: theme.palette.text.secondary,
      border: '1px solid #EFF1F5',
      borderRadius: theme.shape.borderRadius,
      boxShadow: '0px 7px 10px rgba(55, 73, 107, 0.0818127)',
    },
    closeButton: {
      position: 'absolute',
      top: '0',
      right: '0',
    },
    closeButtonIcon: {
      fontSize: '12px',
    },
  }),
  { name: 'TooltipExclamation' }
);
